"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8944%3A1597))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.683Z
 * @optimized using svgo:^3.0.2
 */
export const Slovakia = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2v12h16V2z"
      fill="#3D58DB"
    />
    <mask
      id="mask0_8944_1597"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="16"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2v12h16V2z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#mask0_8944_1597)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2v4h16V2z"
        fill="#F7FCFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10v4h16v-4z"
        fill="#E31D1C"
      />
      <path
        d="m8.802 5.015.249-.026-.024-.224H3.94l-.016.234v.007l-.002.023-.005.088q-.043.672-.072 1.345c-.032.77-.053 1.67.003 2.092.109.82.61 2.665 2.543 3.5l.101.043.1-.045c1.838-.821 2.452-2.475 2.594-3.497.071-.516.035-1.418-.015-2.168q-.047-.686-.116-1.369l-.002-.021v-.008z"
        fill="#E31D1C"
      />
      <path
        d="m3.923 4.999.016-.234h5.088l.024.224-.249.026.25-.026v.008l.002.021q.07.683.116 1.369c.05.75.086 1.652.015 2.168-.142 1.022-.756 2.676-2.594 3.497l-.1.045-.1-.043c-1.935-.835-2.435-2.68-2.544-3.5-.056-.421-.035-1.323-.003-2.093q.03-.672.072-1.344l.005-.088.002-.022v-.009Zm0 0 .25.016"
        stroke="#fff"
        strokeWidth=".5"
      />
      <mask
        id="mask1_8944_1597"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="4"
        width="7"
        height="9"
      >
        <path
          d="m8.802 5.015.249-.026-.024-.224H3.94l-.016.234v.007l-.002.023-.005.088q-.043.672-.072 1.345c-.032.77-.053 1.67.003 2.092.109.82.61 2.665 2.543 3.5l.101.043.1-.045c1.838-.821 2.452-2.475 2.594-3.497.071-.516.035-1.418-.015-2.168q-.047-.686-.116-1.369l-.002-.021v-.008z"
          fill="#fff"
        />
        <path
          d="m3.923 4.999.016-.234h5.088l.024.224-.249.026.25-.026v.008l.002.021q.07.683.116 1.369c.05.75.086 1.652.015 2.168-.142 1.022-.756 2.676-2.594 3.497l-.1.045-.1-.043c-1.935-.835-2.435-2.68-2.544-3.5-.056-.421-.035-1.323-.003-2.093q.03-.672.072-1.344l.005-.088.002-.022v-.009Zm0 0 .25.016"
          stroke="#fff"
          strokeWidth=".5"
        />
      </mask>
      <g mask="url(#mask1_8944_1597)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.128 5.295s.104.157.15.398c.046.24.054.662.054.662l-.979-.121v.743l1.001-.128-.016.705s-.3.031-.545 0-.73-.161-.73-.161v.85s.491-.157.73-.193c.237-.037.545 0 .545 0v1.044h.406V8.05s.444-.039.71.003.516.19.516.19v-.85s-.255.127-.495.159c-.24.031-.73.002-.73.002l.015-.705s.333-.034.52-.009c.186.026.42.137.42.137v-.743s-.228.124-.407.146c-.179.023-.555-.025-.555-.025s.007-.435.045-.647c.04-.212.148-.413.148-.413z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.449 10.123s.22-.472.577-.562c.358-.09.733.28.733.28s.229-.747.787-.747.754.748.754.748.238-.28.58-.28c.343 0 .66.56.66.56S7.517 11.98 6.495 11.98s-2.046-1.857-2.046-1.857"
          fill="#2E42A5"
        />
      </g>
    </g>
    <path stroke="#757575" d="M1 2H17V14H1z" />
  </>,
  "Slovakia",
  { fill: "none", viewBox: "0 0 18 16" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
